export const formatLocalDateTime = (dateTime) => {
    let dateTimeArr = dateTime.split(' ');
    let date = dateTimeArr[0].split('-');
    let time = dateTimeArr[1].split(':');

    return {
        year: date[0],
        month: date[1],
        day: date[2],
        hour: time[0],
        minute: time[1],
        second: time[2],
    }
};
